import axios from "axios";
import { AuthHeaders, decryptResponse } from "./util";

export const getOperatorReport = async (
    page,
    limit,
    fromDate,
    toDate,
    search
) => {
    try {
        const response = await axios.get(`/api/operators?page=${page}&limit=${limit}&createdFromDate=${fromDate}&createdToDate=${toDate}&search=${search}`, {
            'headers': AuthHeaders()
        })
       if (response.status === 200) {
            response.data = decryptResponse(response?.data);
            return response?.data;
       } else return "Something went wrong";
    } catch (error) {
        return error.response.data;
    }
}